
import { RelatedEntityData } from "@/hooks/useRelatedEntities";
import { User, Briefcase, Building2, HandshakeIcon, Contact } from "lucide-react";

interface RelatedEntityListProps {
	entities: RelatedEntityData[];
	entityType: 'candidates' | 'offers' | 'companies' | 'matches' | 'contacts';
	maxDisplay?: number;
}

export const RelatedEntityList = ({ 
	entities, 
	entityType, 
	maxDisplay = 2 
}: RelatedEntityListProps) => {
	if (!entities || entities.length === 0) return null;
	
	const getIcon = () => {
		switch (entityType) {
			case "candidates": return <User className="h-4 w-4 text-blue-500" />;
			case "offers": return <Briefcase className="h-4 w-4 text-green-500" />;
			case "companies": return <Building2 className="h-4 w-4 text-purple-500" />;
			case "matches": return <HandshakeIcon className="h-4 w-4 text-orange-500" />;
			case "contacts": return <Contact className="h-4 w-4 text-gray-500" />;
		}
	};
	
	// Display a limited number of entities, with a +X more if there are additional ones
	const displayedEntities = entities.slice(0, maxDisplay);
	const remainingCount = entities.length - maxDisplay;
	
	return (
		<div className="flex items-center gap-2">
			{getIcon()}
			<div>
				{displayedEntities.map((entity, index) => (
					<span key={entity.id} className="text-sm">
						{entity.name}
						{index < displayedEntities.length - 1 && ", "}
					</span>
				))}
				{remainingCount > 0 && (
					<span className="text-sm text-gray-500 ml-1">
						+{remainingCount} more
					</span>
				)}
			</div>
		</div>
	);
};
